/* icon/UI 24px/Circle Check (approve, complete, verified, valid, done).svg: width 24px x height 24px */
export default class DlsIconCircleCheck extends HTMLElement {
  static define(tagName = 'dls-icon-circle-check') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" display="block" pointer-events="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M22.25 12c0 5.66-4.59 10.25-10.25 10.25S1.75 17.66 1.75 12C1.75 6.339 6.34 1.75 12 1.75S22.25 6.339 22.25 12z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M7.486 11.852l3.032 3.016 5.996-5.96"/></svg>`;
  }
}
DlsIconCircleCheck.define();
